import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    localStorage.removeItem("bkprod_connexion_en_cours"); // reprise de connexion devenue inutile
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        await login(data.token);
        navigate("/", { replace: true });
      } catch (e) {
        window.history.replaceState(null, "", "/login");
        toast.error(errMsg(e, "Connexion Google impossible"));
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0A0A0A] text-white/70">
      <div className="flex items-center gap-3 text-sm" data-testid="auth-callback">
        <Loader2 className="animate-spin" size={18} /> Connexion en cours…
      </div>
    </div>
  );
}
